import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const workflowApp = defineConnector({
  identifier: "workflow",
  name: "Workflow",
  tagLine: "Call another workflow as an API",
  logo,
  protocol: "http",
  tags: ["custom"],
  defaultUrlPattern: (cfg: Record<string, string>) =>
    domainToRegex(cfg.baseUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "X-3B-Connected-App-Auth",
        value: `${app.id}:{secrets.routeAuthToken}`,
      },
    ]),
  steps: [
    {
      title: "Choose a workflow",
      items: [
        {
          kind: "workflow-picker",
          label: "Workflow",
          helperText: "Calls to this connector run the selected workflow.",
        },
        {
          kind: "exposed-routes",
          label: "Links",
          helperText: "Other workflows call these links to run this workflow.",
        },
      ],
    },
  ],
  connectionTest: { protocol: "http", request: () => ({ url: "" }) },
  publicEnvVars: (cfg: Record<string, string>): Record<string, string> =>
    cfg.baseUrl ? { WORKFLOW_URL: cfg.baseUrl } : {},
});
